module.exports = __webpack_public_path__ + "./images/08993c7a29b4c2d0c4e09bdfb8e8d68e.jpg";